import {
  BookOpen,
  ChartColumn,
  CreditCard,
  FileUp,
  House,
  Languages,
  List,
  type LucideIcon,
  MessageSquare,
  Palette,
  QrCode,
  Salad,
  SlidersVertical,
} from "lucide-react";

// Navigation groups and labels exactly as in the approved prototype (Meniova App.dc.html, NAV), plus
// "Valori nutriționale" (paid add-on; the owner's explicit decision 2026-10-28 overrides the prototype nav).
// Paths follow the master specification §11.

export interface NavItem {
  id: string;
  path: string;
  label: string;
  icon: LucideIcon;
}

export const NAV: ReadonlyArray<{ label: string; items: NavItem[] }> = [
  {
    label: "Meniu",
    items: [
      { id: "overview", path: "/app", label: "Prezentare generală", icon: House },
      { id: "menus", path: "/app/menus", label: "Meniurile mele", icon: BookOpen },
      { id: "products", path: "/app/products", label: "Produse și categorii", icon: List },
      { id: "import", path: "/app/imports", label: "Import AI", icon: FileUp },
      { id: "nutrition", path: "/app/nutrition", label: "Valori nutriționale", icon: Salad },
    ],
  },
  {
    label: "Prezentare",
    items: [
      { id: "appearance", path: "/app/appearance", label: "Aspect și personalizare", icon: Palette },
      { id: "translations", path: "/app/translations", label: "Traduceri", icon: Languages },
      { id: "qr", path: "/app/qr", label: "Coduri QR", icon: QrCode },
    ],
  },
  {
    label: "Activitate",
    items: [
      { id: "stats", path: "/app/analytics", label: "Statistici", icon: ChartColumn },
      { id: "feedback", path: "/app/feedback", label: "Feedback", icon: MessageSquare },
    ],
  },
  {
    label: "Cont",
    items: [
      { id: "billing", path: "/app/billing", label: "Abonament și facturare", icon: CreditCard },
      { id: "settings", path: "/app/settings", label: "Setări", icon: SlidersVertical },
      // Chat with the Meniova team (owner 2026-11-03).
    ],
  },
];

export const NAV_FLAT = NAV.flatMap((g) => g.items);

/** Mobile bottom navigation (prototype MOB): Acasă, Meniu, Import, QR, Mai mult. */
export const MOBILE_TABS = ["overview", "products", "import", "qr"] as const;
